import { Button } from '@cian/ui-kit';
import * as React from 'react';
import { TitleContainer } from '../TitleContainer';
import { Agreement } from '../../_NEXT_components/Agreement';
import { AgreementLayout } from '../../_NEXT_components/AgreementLayout';
import { previousView } from '../../actions/view';
import { acceptLicence, acceptMarketingSubscription, applyAgreement } from '../../actions/agreement';
import { trackAgreementOpen, trackBackButtonClick, trackNextButtonClick } from './tracking';
import { selectAgreement, selectIsAgreementNextLoading } from './selectors';
export var AgreementContainer = function AgreementContainer(_ref) {
  var useSelector = _ref.useSelector,
      useDispatch = _ref.useDispatch;
  var dispatch = useDispatch();
  var isLoading = useSelector(selectIsAgreementNextLoading);

  var _useSelector = useSelector(selectAgreement),
      marketingSubscriptionAccepted = _useSelector.marketingSubscriptionAccepted,
      licenceAccepted = _useSelector.licenceAccepted;

  React.useEffect(function () {
    trackAgreementOpen();
  }, []);
  var handleAgreementChange = React.useCallback(function (e, value) {
    dispatch(acceptLicence(value));
  }, [dispatch]);
  var handleSubscriptionChange = React.useCallback(function (e, value) {
    dispatch(acceptMarketingSubscription(value));
  }, [dispatch]);
  var handleNextClick = React.useCallback(function () {
    trackNextButtonClick({
      licenceAccepted: licenceAccepted,
      marketingSubscriptionAccepted: marketingSubscriptionAccepted
    });
    dispatch(applyAgreement());
  }, [dispatch, licenceAccepted, marketingSubscriptionAccepted]);
  var handlePreviousClick = React.useCallback(function () {
    trackBackButtonClick();
    dispatch(previousView());
  }, [dispatch]);
  return /*#__PURE__*/React.createElement(AgreementLayout, {
    title: /*#__PURE__*/React.createElement(TitleContainer, null),
    agreement: /*#__PURE__*/React.createElement(Agreement, {
      agreementAccepted: licenceAccepted,
      subscriptionAccepted: marketingSubscriptionAccepted,
      onAgreementChange: handleAgreementChange,
      onSubscriptionChange: handleSubscriptionChange
    }),
    controls: [/*#__PURE__*/React.createElement(Button, {
      key: "next",
      type: "button",
      theme: "fill_primary",
      disabled: !licenceAccepted,
      loading: isLoading,
      onClick: handleNextClick,
      fullWidth: true
    }, "\u041F\u0440\u043E\u0434\u043E\u043B\u0436\u0438\u0442\u044C"), /*#__PURE__*/React.createElement(Button, {
      key: "previous",
      type: "button",
      theme: "fill_secondary",
      disabled: isLoading,
      onClick: handlePreviousClick,
      fullWidth: true
    }, "\u041D\u0430\u0437\u0430\u0434")]
  });
};